import type { BibleBook } from "@packages/sdk";
import type { CSSProperties, MouseEvent } from "react";
import { forwardRef } from "react";

import { BibleNavItem } from "./BibleNavItem";

export type BibleNavBookItemProps = {
  b: BibleBook;
  idx: number;
  onItemClick: (e: Event | MouseEvent) => void;
  itemStyle: (idx: number) => CSSProperties | undefined;
  selected: boolean;
  className?: string;
};

export const BibleNavBookItem = forwardRef<
  HTMLDivElement,
  BibleNavBookItemProps
>(({ b, idx, onItemClick, className = "", itemStyle, selected }, ref) => (
  <BibleNavItem
    id={b.id}
    onItemClick={onItemClick}
    selected={selected}
    className={className}
    styleOverride={itemStyle(idx) ?? undefined}
    targetTabValue={"chapter"}
    ref={ref}
  >
    {b.long_name ?? b.name}
  </BibleNavItem>
));

BibleNavBookItem.displayName = "BibleNavBookItem";
